import { createEnv, envString, envBoolean, z } from '@percent/utility'

export const env = createEnv({
  schema: {
    NODE_ENV: z.string().optional(),
    NX_PUBLIC_REACT_APP_ENV: envString(),
    NX_REACT_APP_ENV: z.string().optional(),
    NX_PUBLIC_SPLIT_KEY: z.string().optional(),
    NX_PUBLIC_USE_SENTRY_LOGGER: envBoolean().optional(),
    NX_PUBLIC_SENTRY_DSN: z.string().optional(),
    NX_PUBLIC_API_URL: envString(),
    // Use NX_PUBLIC_API_URL exactly as given, skipping the domain rewrite in config.ts.
    // Only for pairing a locally-served app with a locally-run api - see config.ts.
    NX_PUBLIC_API_URL_VERBATIM: envBoolean().optional(),
    NX_TEST_MODE: envBoolean().optional(),
    NX_PUBLIC_TEST_MODE: envBoolean().optional(),
    NX_PUBLIC_APP_URL: envString(),
    NX_PUBLIC_DISBURSEMENT_PREVIEW_URL: envString(),
    NX_PUBLIC_DONATION_REQUEST_PREVIEW_URL: envString(),
    NX_PUBLIC_DONATION_MATCH_REQUEST_URL: envString(),
    NX_PUBLIC_VR_AUTOMATION_ACCOUNT_ID: z.string().optional(),
    NX_PUBLIC_POSTHOG_API_KEY: z.string().optional(),
    NX_PUBLIC_RECAPTCHA_SITE_KEY: z.string().optional(),
    // Development only - see common/hooks/usePostHogFeatureFlag/developmentFlagOverrides.ts.
    NX_PUBLIC_POSTHOG_FLAG_OVERRIDES: z.string().optional()
  }
})
